<template>
    <div>
        <app-card
            headerIcon="vibration"
            :heading="$t('lang.device_alerts')"
            colClasses=""
            customClasses="mb-0"
            :fullScreen="true"
            :reloadable="true"
            :closeable="true"
            :fullBlock="true"
            :footer="true"
            :reload="reload"
            :count="page.total_records"
        >
            <device-alerts></device-alerts>
            <bc-pagination
                class="small-pagination"
                slot="footer"
                :page="page"
                :params="axiosParams"
                sendCommit="mutateUpdateDashboardDeviceAlerts"
            ></bc-pagination>
            <v-spacer slot="footer"></v-spacer>
            <v-btn
                slot="footer"
                color="primary"
                @click="$router.push({ name: 'devices', query: { has_alerts: '1', page_num: dashboard_device_alerts_page_num } })"
                small
                >{{ $t("lang.view_all") }}</v-btn
            >
            <v-btn slot="header" icon small @click="refreshDeviceAlerts"><v-icon>refresh</v-icon></v-btn>
        </app-card>
    </div>
</template>
<script>
import DeviceAlerts from "App_components/Widgets/DeviceAlerts.vue";
import { mapActions, mapState } from "vuex";
export default {
    components: {
        DeviceAlerts,
    },
    data() {
        return {
            name: "device_alerts",
            reload: false,
            filter: {
                search: "",
                status: "active",
                company_id: null,
                device_type_id: null,
                tags: [],
                page_size: 0,
                page_num: 0,
                connection_status: "",
            },
        };
    },
    computed: {
        ...mapState({
            devices: (state) => state.devices.devices,
            device_alerts: (state) => state.devices.device_alerts,
            default_filter: (state) => state.devices.devices_filter,
            page: (state) => state.devices.device_alerts_page,
            dashboard_device_alerts_page_num: (state) => state.devices.dashboard_device_alerts_page_num,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchDevices"]),
        refreshDeviceAlerts() {
            this.reload = true;
            this.$store.commit("mutate", {
                property: "device_alerts",
                with: [],
            });
            this.fetchDevices({
                body: {
                    has_alerts: "1",
                    page_num: this.dashboard_device_alerts_page_num,
                    tags: this.current_user.tags_filter !== null ? [...this.current_user.tags_filter.split(",")] : [],
                },
            }).then((data) => {
                this.$store.commit("mutate", {
                    property: "device_alerts",
                    with: [...this.devices],
                });
                this.reload = false;
            });
            console.log(this.reload);
        },
    },
};
</script>
